import Cell from "components/templatesComponents/table/Cell";
import PropTypes from "prop-types";
import React from "react";

const Row = (props) => {
  const { cells = [], isHeader = false } = props;

  if (!cells || cells.length === 0) {
    return null;
  }
  const arrayCells = Array.isArray(cells) ? cells : [cells];

  return (
    <tr role="row">
      {arrayCells.map((cell) => (
        <Cell {...cell} isHeader={isHeader} key={`cell-${cell.id}`} />
      ))}
    </tr>
  );
};

Row.propTypes = {
  cells: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  isHeader: PropTypes.bool,
};

export default Row;
